import { createSlice } from "@reduxjs/toolkit";

const getDefaultYear = () => {
  const today = new Date();

  const currentYear = today.getFullYear();
  const april30 = new Date(currentYear, 3, 30);
  // Up to 30th April => current year
  // After 30th April => next year
  return today <= april30 ? String(currentYear) : String(currentYear + 1);
};

const initialState = {
  customerDetails: [],
  selectedCustomerDetail: JSON.parse(
    localStorage.getItem("selectedCustomerDetail")
  ) || null,
  selectedCustomerSummaryFilters: {
    selectedYear: getDefaultYear(),
    selectedHandler: "",
    selectedKdNumber: "",
    selectedLand: "",
    selectedActive: "",
    selectedPlanned: "",
    selectedTemplate: "",
    selectedType: "VK",
    selectedVtr: "",
    selectedVtrGroup: "",
    handlerName: "",
    selectedOldCustomer:"J"
  },
};

const CustomerSlice = createSlice({
  name: "customer",
  initialState,
  reducers: {
    customerSummary: (state, action) => {
      // state.customerDetails.push(action.payload);
      // console.log('action customer', action.payload)
      state.customerDetails = action.payload;
    },

    // NEW reducer
    setSelectedCustomerDetail: (state, action) => {
      state.selectedCustomerDetail = action.payload;

      localStorage.setItem(
        "selectedCustomerDetail",
        JSON.stringify(action.payload)
      );
      // console.log("its set for redux")
    },

    // NEW reducer - clears both redux state and localStorage
    clearSelectedCustomerDetail: (state) => {
      state.selectedCustomerDetail = null;
      localStorage.removeItem("selectedCustomerDetail");
      localStorage.removeItem("planningLock"); // add this
      // console.log("its remove for redux")
    },

    setSelectedCustomerSummaryFilters: (state, action) => {
      const { key, value } = action.payload;

      state.selectedCustomerSummaryFilters[key] = value;
    },
    resetCustomerSummaryFilters: (state) => {
      state.selectedCustomerSummaryFilters =
        initialState.selectedCustomerSummaryFilters;
    },
  },
});

export const {
  customerSummary,
  setSelectedCustomerDetail,
  clearSelectedCustomerDetail,
  setSelectedCustomerSummaryFilters,
  resetCustomerSummaryFilters
} = CustomerSlice.actions;
export default CustomerSlice.reducer;
